module.exports = __webpack_public_path__ + "static/media/person.db4a5d02.png";